export default "<p>base-crud works!</p>\n"